import { HashRouter } from "react-router-dom";
import Home from "./Home";

function App() {
  return (
    <>
      <HashRouter>
        <Home />
      </HashRouter>
    </>
  );
}

export default App;
